import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function archiveThreadMessageFailure(draft: Draft<IInterventionData>) {
  draft.archiveThreadMessage.config.isLoading = false;
}

export default archiveThreadMessageFailure;
